// import $ from "jquery/dist/jquery";
import MicroModal from 'micromodal';

/**
 * disableScroll:trueにすることで、Bodyスクロールを止められる（modal open時にbodyへstyleが付与される）が、
 * modalが多重階層になった時、ひとつでも閉じるとBodyスクロールストップが解除されてしまうので、
 * modalを1度に複数個開く時は、手動でBodyスクロールを止める
 */

/**
 * モーダルを閉じた際、スクロール位置を開く前と同じに戻す用
 */
let iScrollPos = 0;

// modal開いた時（モーダルを複数階層にする時）
function onShowModal(){
	$('html').addClass('body-scroll-stop');
}
// modal閉じた時（モーダルを複数階層にする時）
function onCloseModal(){
	$('html').removeClass('body-scroll-stop');
	$(window).scrollTop(iScrollPos);
}

/**
 * open modal
 */
$(function(){
    // 画面表示時処理
    $(document).ready(function () {
        $('.check-box-btn').each(function () {
            var labels = '';
            var modalSmallId = this.parentElement.parentElement.id;
            $('#'+modalSmallId+' input:checked').each(function() {
              var check = $(this).attr('id');
              var label = $('label[for="' + check + '"]').text();
              labels += label != '' ? ( labels != '' ? ',' : '' ) + label : '';
            });
            labels = labels.length > 0 ? labels : '選択してください';
            if (document.getElementById('select-btn') == null) {
                $(this).parents('.modal-class').next().children('button').children().text(labels);
            } else {
                $('#select-btn').text(labels);
            }
            console.log(labels);
          });
        $('.check-box-btn2').each(function () {
            var labels2 = '';
            var modalSmallId = this.parentElement.parentElement.id;
            $('#'+modalSmallId+' input:checked').each(function () {
              var check2 = $(this).attr('id');
              var label2 = $('label[for="' + check2 + '"]').text();
              labels2 += label2 != '' ? (labels2 != '' ? ',' : '') + label2 : '';
            });
            labels2 = labels2.length > 0 ? labels2 : '選択してください';
            if (document.getElementById('select-btn2') == null) {
                $(this).parents('.modal-class').next().children('button').children().text(labels2);
            } else {
                $('#select-btn2').text(labels2);
            }
            console.log(labels2);
          });
    });
    // 求人掲載
    $('.open-modal-register-job-offer').on('click', function(event){
        event.preventDefault();
        iScrollPos = $(window).scrollTop();
        $(".registration-box .area2").removeClass("is-active");
        $('#salon-registration').addClass("is-active");
        $("ul.registration-wrap li").removeClass("active");
        $("ul.registration-wrap li.salon").addClass("active");

        MicroModal.show('modal-2', {
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
            onShow: modal => onShowModal(),
            onClose: modal => onCloseModal()
        });
	});
    // login
    $('.open-modal-login').on('click', function(event){
        event.preventDefault();
        iScrollPos = $(window).scrollTop();

        MicroModal.show('modal-1', {
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });
	});
    // register
    $('.open-modal-register').on('click', function(event){
        event.preventDefault();
        iScrollPos = $(window).scrollTop();

        MicroModal.show('modal-2', {
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });
	});
  // 美容師登録
  $('.open-modal-register-b').on('click', function (event) {
    event.preventDefault();
    iScrollPos = $(window).scrollTop();

    MicroModal.show('modal-b', {
      openClass: 'is-open',
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
    });
  });
  // 店舗登録
  $('.open-modal-register-s').on('click', function (event) {
    event.preventDefault();
    iScrollPos = $(window).scrollTop();

    MicroModal.show('modal-s', {
      openClass: 'is-open',
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
    });
  });

    // 検索条件：仕事ジャンル
    $('.open-modal-condition-genre').on('click', function(event){
        event.preventDefault();
        iScrollPos = $(window).scrollTop();

        var modalId = '';
        if (this.parentElement.previousElementSibling == null) {
            modalId = $(this).attr('data-micromodal-trigger');
        } else {
            modalId = this.parentElement.previousElementSibling.id;
        }
        MicroModal.show(modalId, {
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });
	});
    //--文字の結合
    $(function() {
        var clickEventType = (( window.ontouchstart!==null ) ? 'click':'touchend');
        $('.check-box-btn').on(clickEventType, function () {
          var labels = '';
          var modalSmallId = this.parentElement.parentElement.id;
          $('#'+modalSmallId+' input:checked').each(function() {
            var check = $(this).attr('id');
            var label = $('label[for="' + check + '"]').text();
            labels += label != '' ? ( labels != '' ? ',' : '' ) + label : '';
          });
          labels = labels.length > 0 ? labels : '選択してください';
          if (document.getElementById('select-btn') == null) {
            $(this).parents('.modal-class').next().children('button').children().text(labels);
          } else {
            $('#select-btn').text(labels);
          }
          console.log(labels);
        });
      });

    // 検索条件：こだわり
    $('.open-modal-condition-picky').on('click', function(event){
        event.preventDefault();
        iScrollPos = $(window).scrollTop();

        var modalId = '';
        if (this.parentElement.previousElementSibling == null) {
            modalId = $(this).attr('data-micromodal-trigger');
        } else {
            modalId = this.parentElement.previousElementSibling.id;
        }
        MicroModal.show(modalId, {
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });
	});
     //--文字の結合
    $(function() {
        var clickEventType2 = (( window.ontouchstart!==null ) ? 'click':'touchend');
        $('.check-box-btn2').on(clickEventType2, function () {
          var labels2 = '';
          var modalSmallId = this.parentElement.parentElement.id;
          $('#'+modalSmallId+' input:checked').each(function() {
            var check2 = $(this).attr('id');
            var label2 = $('label[for="' + check2 + '"]').text();
            labels2 += label2 != '' ? ( labels2 != '' ? ',' : '' ) + label2 : '';
          });
          labels2 = labels2.length > 0 ? labels2 : '選択してください';
          if (document.getElementById('select-btn2') == null) {
            $(this).parents('.modal-class').next().children('button').children().text(labels2);
          } else {
            $('#select-btn2').text(labels2);
          }
          console.log(labels2);
        });
      });



    // 検索条件を保存
    $('.open-modal-save-conditions').on('click', function(event){
        event.preventDefault();
        iScrollPos = $(window).scrollTop();

        MicroModal.show('modal-save-conditions', {
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });
	});
    // 検索条件を読み込む
    $('.open-modal-load-conditions').on('click', function(event){
        event.preventDefault();
        iScrollPos = $(window).scrollTop();

        MicroModal.show('modal-load-conditions', {
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });
	});
});

$(function(){
    MicroModal.init({
      onShow: modal => console.info(`${modal.id} is shown`), // [1]
      onShow: (modal, e) => { console.log('modal onShow:modal', modal); console.log('modal onShow:target', e.target); },
      onClose: (modal, e) => { console.log('modal onShow:modal', modal); console.log('modal onShow:target', e.target); },
      openTrigger: 'data-custom-trigger',
      openClass: 'is-open', // [5]
      disableScroll: true, // [6]
      disableFocus: false, // [7]
      awaitOpenAnimation: true,
      awaitCloseAnimation: true
    });
});


